import {Component, EventEmitter, Input, Output} from '@angular/core'


@Component({
  selector: 'dmmp-card-related-program',
  templateUrl: './card-related-program.component.html',
})
export class CardRelatedProgramComponent {
  @Input() flag
  @Input() backgroundColorFlag
  @Input() image
  @Input() medias
  @Input() category
  @Input() title
  @Input() titleClass
  @Input() duration
  @Input() modality
  @Input() button
  @Output() page = new EventEmitter()
  labelCard = {duration: 'Duración:', modality: 'Modalidad:'}
}
